import React from "react";
import { useCachedImage } from "../../utils/imageCache";

const CachedImage = ({
  src,
  alt,
  fallbackSrc,
  className = "",
  showLoader = true,
  ...props
}) => {
  const { imageUrl, isLoading, error } = useCachedImage(src, fallbackSrc);

  return (
    <div className={`relative ${className}`}>
      {isLoading && showLoader && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-gray-600"></div>
        </div>
      )}
      <img
        src={imageUrl}
        alt={alt}
        className={`w-full h-full object-contain ${isLoading ? "opacity-0" : "opacity-100"} transition-opacity duration-200`}
        {...props}
      />
      {error && !isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100 rounded text-xs text-gray-500">
          {alt?.substring(0, 3) || "?"}
        </div>
      )}
    </div>
  );
};

export default CachedImage;
